import React from 'react';
import ReactDOM from 'react-dom/client';
// Base Styles
import './styles/base/_reset.css';
import './styles/base/_antd-overrides.css';

// Utility Classes (Order might matter slightly between utilities, but generally grouped is fine)
import './styles/utilities/_layout.css';
import './styles/utilities/_spacing.css';
import './styles/utilities/_typography.css';
import './styles/utilities/_colors.css';
import './styles/utilities/_borders.css';
import './styles/utilities/_shadows.css';
import './styles/utilities/_misc.css';

// Animations (Place before components that use them)
import './styles/components/_animations.css';

// Component Styles
import './styles/components/_navbar.css';
import './styles/components/_section.css'; // General section styles first
import './styles/components/_hero.css';
import './styles/components/_mailinglist.css';
import './styles/components/_characterprofile.css';
import './styles/components/_militarymodal.css';
import './styles/components/_newsgallery.css';
import './styles/components/_contact.css';

// App Component and other JS imports
import App from './App'; // Your main App component
import reportWebVitals from './reportWebVitals';
import { ContextProvider } from './store/Context'; // Assuming ContextProvider setup

// Remove the original import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ContextProvider>
      <App />
    </ContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
